(function (ws) {
    'use strict';

    ws.models.shippingState = Backbone.Model.extend({});

}(westcon));
